if(!customElements.get("side-offers")) {
  customElements.define("side-offers", class SideOffers extends HTMLElement {
    constructor() {
      super();
      this.offersOverlay = this.querySelector(".side-offers__overlay");
      this.closeBtn = this.querySelector(".side-offers__close");
      this.offer_button = document.getElementById("side_offers");
      this.offer_button.addEventListener("click", this.openOffers.bind(this));
      this.mobile_button = document.getElementById("mobile_offers");
      this.mobile_button.addEventListener("click", this.openOffers.bind(this));
      this.initOffers();
    }
    initOffers() {
      if(this.offersOverlay) {
        this.offersOverlay.addEventListener("click", this.closeOffers.bind(this));
      }
      if(this.closeBtn) {
        this.closeBtn.addEventListener("click", this.closeOffers.bind(this));
      }
    }
    openOffers() {
      this.classList.add("offers--open");
      const list = document.body.classList;
      list.add('overflow-hidden');
    }
    closeOffers() {
      this.classList.remove("offers--open");
      const list = document.body.classList;
      list.remove('overflow-hidden');
    }
  });
}


if(!customElements.get("side-offer-detail")) {
  customElements.define("side-offer-detail", class SideOfferDetail extends HTMLElement {
    constructor() {
      super();
      this.detailOverlay = this.querySelector(".side-offer-detail__overlay");
      this.closeBtn = this.querySelector(".side-offer-detail__close");
      this.showOfferDetail = this.querySelector(".offer-detail");
      this.showOfferDetail.addEventListener("click", this.openDetail.bind(this));
      this.addDiscountButton = this.querySelector(".add-discount-button");
      // this.addDiscountButton.addEventListener("click", this.addDiscount.bind(this));
      this.initDetail();
    }
    initDetail() {
      if(this.detailOverlay) {
        this.detailOverlay.addEventListener("click", this.closeDetail.bind(this));
      }
      if(this.closeBtn) {
        this.closeBtn.addEventListener("click", this.closeDetail.bind(this));
      }
    }
    openDetail() {
      this.classList.add("detail--open");
    }
    closeDetail() {
      this.classList.remove("detail--open");
    }
    addDiscount() {
      var cartContents = fetch(window.Shopify.routes.root + 'cart.js')
        .then(response => response.json())
        .then(data => { console.log(data
        ) });
    }
  });
}